import React from 'react';
import { Card, Header, Label } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { codeUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import DatasetStatusButtons from '@/datasets/status/components/DatasetStatusButtons';
import SystemFlag from '@/components/SystemFlag';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';

const SearchResultCardItem = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  code,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  compact,
  dataModelName,
  description,
  hasConditions,
  keyword,
  name,
  newCohort,
  newCohortCode,
  newRequestCode,
  primaryDictionary,
  showConditions,
  visibility,
}) => (
  <CardItem className="aridhia-search-result-list-item">
    <NameDescriptionCard
      description={description}
      entity="search"
      icon="table"
      system={!!dataModelName}
      renderSystemFlag={() => <SystemFlag messageText={dataModelName} flush />}
      link={codeUrl(urls.DATASETS, code)}
      markdown
      name={name}
      visibility={visibility}
    >
      {(accessRequestAllowed || cohortAllowed) && (
        <DatasetStatusButtons
          accessRequestAllowed={accessRequestAllowed}
          accessRequestSupported={accessRequestSupported}
          accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
          className="float-r h-24"
          code={code}
          cohortAllowed={cohortAllowed}
          cohortSupported={cohortSupported}
          cohortUnsupportedReasons={cohortUnsupportedReasons}
          dictionaryCode={primaryDictionary}
          hasConditions={hasConditions}
          icon
          name={name}
          newCohort={newCohort}
          newCohortCode={newCohortCode}
          newRequestCode={newRequestCode}
          showConditions={showConditions}
        />
      )}
    </NameDescriptionCard>
    {!compact && keyword && keyword.length > 0 && (
      <Card.Content extra className="overflow-auto">
        <Header as="h5">
          <FormattedMessage id="search.result.keyword" />
        </Header>
        {keyword.map((i) => (<Label className="aridhia-h4 aridhia-tag" key={code + i} content={i} />))}
      </Card.Content>
    )}
  </CardItem>
);

export default SearchResultCardItem;
